import { render, staticRenderFns } from "./SubmissionAddStep1.vue?vue&type=template&id=fd3cb64e"
import script from "./SubmissionAddStep1.vue?vue&type=script&lang=js"
export * from "./SubmissionAddStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports